var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { PaginationItem, usePagination } from '@material-ui/lab';
export function Pagination(_a) {
    var count = _a.count, page = _a.page, onChange = _a.onChange;
    var items = usePagination({
        page: page,
        count: count,
        showFirstButton: true,
    }).items;
    var grouped = items.reduce(function (acc, item) {
        if (!acc[item.type]) {
            acc[item.type] = [];
        }
        var required = item.type !== 'page' ||
            (page === 1 && item.page <= 3) ||
            (page === count && item.page >= count - 2) ||
            (item.page >= page - 1 && item.page <= page + 1);
        if (required) {
            acc[item.type].push(item);
        }
        return acc;
    }, {});
    if (count > 3) {
        if (page >= 3) {
            grouped['start-ellipsis'] = [
                {
                    disabled: false,
                    page: 0,
                    selected: false,
                    type: 'start-ellipsis',
                    onClick: function () {
                        // noop
                    },
                },
            ];
        }
        if (page <= count - 2) {
            grouped['end-ellipsis'] = [
                {
                    disabled: false,
                    page: 0,
                    selected: false,
                    type: 'end-ellipsis',
                    onClick: function () {
                        // noop
                    },
                },
            ];
        }
    }
    var renderItem = function (prefix) {
        return function renderItem(item, index) {
            return (_createElement(PaginationItem, __assign({}, item, { key: "".concat(prefix, "-").concat(index), onClick: function () { return onChange(item.page); } })));
        };
    };
    return (_jsxs("div", { className: "faq-pagination", children: [grouped.first && grouped.first.map(renderItem('first')), grouped.previous && grouped.previous.map(renderItem('previous')), _jsx("div", { className: "faq-pagination-start-ellipsis", children: grouped['start-ellipsis'] && grouped['start-ellipsis'].map(renderItem('start-ellipsis')) }), _jsx("div", { className: "faq-pagination-pages", children: grouped.page && grouped.page.map(renderItem('page')) }), _jsx("div", { className: "faq-pagination-end-ellipsis", children: grouped['end-ellipsis'] && grouped['end-ellipsis'].map(renderItem('end-ellipsis')) }), grouped.next && grouped.next.map(renderItem('next')), grouped.last && grouped.last.map(renderItem('last'))] }));
}
//# sourceMappingURL=Pagination.js.map